import { useCallback, useMemo } from "react"
import { State } from "../../state"
import { Cropping, HoldingRole } from "../../types"
import { AppDispatch, useFilteredUsers } from "../hooks"

export function useRestrictedMembers(users: State["users"], filter: string) {

    const members = useMemo(() => users.edits.filter(u => (u.holdingRole === HoldingRole.RestrictedMember) && (!u.deleted)), [users])

    const select = (u: typeof members[number]) => ({
        name: u.displayName,
        email: u.email,
        shouldRetain: false
    })

    return useFilteredUsers(members, filter, select)

}

export function useSetPermissions(dispatch: AppDispatch) {

    return useCallback((userId: number, cropping: Cropping[], authorized: boolean) => {

        dispatch({
            type: "setCroppingPermission",
            payload: {
                userId,
                cropping: cropping.map(c => c.croppingId),
                authorized
            }
        })

    }, [dispatch])

}